import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, tap } from 'rxjs';
import { Project, ProjectInput } from '../models/project.models';
import { environment } from '../../../environments/environment.development';

@Injectable({
  providedIn: 'root'
})
export class ProjectsService {

  constructor(
    private http: HttpClient
  ) { }

  getProjects(): Observable<Project[]> {
    return this.http.get<Project[]>(`${environment.baseUrl}/projects`)
      .pipe(
        catchError(this.handleError<Project[]>('getProjects'))
      );
  }

  getProjectById(id: string): Observable<Project> {
    return this.http.get<Project>(`${environment.baseUrl}/projects/${id}`)
      .pipe(
        catchError(this.handleError<Project>('getProjectById'))
      );
  }

  createProject(project: ProjectInput): Observable<Project> {
    return this.http.post<Project>(`${environment.baseUrl}/projects`, project)
      .pipe(
        catchError(this.handleError<Project>('createProject'))
      );
  }

  updateProject(id: string, project: ProjectInput): Observable<Project> {
    return this.http.put<Project>(`${environment.baseUrl}/projects/${id}`, project)
      .pipe(
        catchError(this.handleError<Project>('updateProject'))
      );
  }

  deleteProject(id: string): Observable<any> {
    return this.http.delete<Project>(`${environment.baseUrl}/projects/${id}`)
      .pipe(
        catchError(this.handleError('deleteProject'))
      );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}


